export default "__VITE_ASSET__e7d98bad__"